/**
 * As part of a larger effort to deprecate and remove Chart.js, this component is deprecated, and improvements
 * should be minimal. Use components in /ui-library/charting/ instead if possible.
 */
import React from 'react';

import Continuous2DChart, {Continuous2DChartProps, Continuous2DChartType} from './Continuous2DChart';

export type DeprecateLineChartProps = Continuous2DChartProps;

export default function DeprecateLineChart(props: DeprecateLineChartProps): JSX.Element {
  return <Continuous2DChart chartType={Continuous2DChartType.LINE} chartProps={props} />;
}
